export default __webpack_public_path__ + "static/media/manawu.c1c3d64b.svg";